import { IDestinationList } from "../../models/IDestinationList";

export class DestinationState {
  destinationList: IDestinationList[] = [];
}
